import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShellComponent } from './shell.component';
import { HeaderComponent } from './header/header.component';
import { ShellRoutingModule } from './shell-routing.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SidebarModule } from 'primeng/sidebar';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ToastModule } from 'primeng/toast';

@NgModule({
  imports: [
    NgxPermissionsModule.forChild(),
    ToastModule,
    CommonModule,
    OverlayPanelModule,
    SidebarModule,
    ShellRoutingModule,
  ],
  declarations: [HeaderComponent, ShellComponent, SidebarComponent, NavbarComponent],
})
export class ShellModule {}
